/* eslint-disable react/jsx-tag-spacing */

import React from 'react';
import _ from 'lodash';
import PetHOC from '../../Global/Pet/PetHOC';

class KittenInTab extends PetHOC {
	constructor(props) {
		super(props);
		this.actions = {
			idle: [
				{
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: () => _.random(500, 6000),
					},
				},
				{
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: () => _.random(200, 3000),
					},
					stop: {
						timeout: null,
						interval: () => 199,
					},
				},
			],
			pet: [
				{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: () => _.random(600, 1200),
					},
				},
			],
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.beingPet === nextProps.beingPet) {
			// If this prop is already applied, return.
			return;
		}

		if (nextProps.beingPet) {
			this.startBeingPet();
		} else {
			this.stopBeingPet();
		}
	}

	render() {
		const styles = {
			svg: {
				enableBackground: 'new 0 0 110 95',
			},
		};

		return (
			<div
				onMouseEnter={this.startBeingPet}
				onMouseLeave={this.stopBeingPet}
				className="cat-wrapper">
				<svg className={`${this.getClassNames()} heart`} style={styles.svg} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 110 95">
					<g className="heart-x-wrapper">
						<g className="heart-y-wrapper">
							<path fill="#fc7e7e" d="M55,30.5421677c0-2.2242432,3.2366257-5.750782,7.2292061-5.750782
							s7.2292061,3.7475796,7.2292061,7.0688534C69.4584122,40.839592,55,49.2948608,55,49.2948608
							S40.5415878,40.839592,40.5415878,31.860239c0-3.3212738,3.2366257-7.0688534,7.2292061-7.0688534S55,28.3179245,55,30.5421677z"/>
					</g>
				</g>
				</svg>
				<svg className={this.getClassNames()} style={styles.svg} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 110 95">
					<path className="fill" d="M108.0690308,59.8454437c0.4884949-13.741478-2.944664-42.9283447-7.824295-54.7815857
						c-1.2200699-3.8865795-6.1605606-6.1623039-9.497673-3.5111153l-0.0000381,0.000037
						c-6.3918457,3.6962204-14.2641602,9.6724939-20.5303192,15.4488993
						c-4.8372269-1.3831635-9.9633408-2.1468201-15.2732277-2.1468201c-5.2785492,0-10.375473,0.7548504-15.1875801,2.1225491
						c-6.2619019-5.768858-14.1213436-11.7336245-20.5041962-15.4246283v-0.000037
						c-3.3371105-2.6511884-8.2776012-0.3754642-9.4977121,3.5111153c-4.85532,11.7941914-8.277194,40.7445602-7.8300261,54.5699883
						c-0.0044398,0.0956802-0.0100267,0.1913567-0.0136526,0.2870369l0.2430454,5.4813385
						c0.1697876,1.2737579,0.4207506,2.5011978,0.7440834,3.685936l1.977181,5.090004
						c0.6899538,1.3389511,1.4912009,2.6082687,2.3978572,3.8081818l3.6963687,4.0227356
						c9.5384836,8.6259766,25.6744537,12.583519,43.9746323,12.583519c17.9594154,0,33.8327675-3.812767,43.4333-12.1077194
						l3.8032913-3.9344177c1.011734-1.2689514,1.9023743-2.6184082,2.664917-4.0482635l2.0485916-5.0656586
						c0.3773499-1.3129425,0.6619415-2.6806793,0.8482666-4.1044617L108.0690308,59.8454437z"/>
					<path className="fill--face" d="M55.7324333,62.4954071c-0.9384651-0.0286217-1.5967026-0.3171959-2.0271797-0.8180275
						l-3.1361694-3.6441574c-0.4889069-0.5699959-0.5962296-1.2735443-0.2945366-1.9293976
						c0.3481979-0.760788,1.1793442-1.2496986,2.1154251-1.2496986h6.2794876c0.9336967,0,1.762455,0.4889107,2.1130409,1.2449265
						c0.3028831,0.6534691,0.1991386,1.3546371-0.2826157,1.9198608l-3.1659775,3.6727753
						c-0.4316711,0.493679-1.0922928,0.7774849-1.8077698,0.7774849L55.7324333,62.4954071z"/>
					<g className="eyes">
						<ellipse className="fill--face" cx="75.9827805" cy="43.2129059" rx="5.589057" ry="6.1697845"/>
						<ellipse className="fill--face" cx="34.8882446" cy="43.2129059" rx="5.5878644" ry="6.1697845"/>
					</g>
					<g className="eyes--blink">
						<path className="fill--face" d="M40.5786324,49.0388565c-0.1149864,0-0.2314301-0.0105515-0.3486023-0.0327492
							l-11.3764019-2.1534538c-1.0108643-0.1914024-1.675312-1.1662407-1.4839115-2.1771049
							c0.1914024-1.0112267,1.1651497-1.6745834,2.1767426-1.4842758l11.3764038,2.1534538
							c1.0108643,0.1914024,1.675312,1.1662407,1.4839096,2.1771049
							C42.2379341,48.4158897,41.4563141,49.0388565,40.5786324,49.0388565z"/>
						<path className="fill--face" d="M70.2923965,49.0389061c-0.8776855,0-1.6593018-0.6229668-1.8281479-1.517025
							c-0.1913986-1.0108643,0.4730453-1.9857025,1.4839096-2.1771049l11.3764038-2.1534538
							c1.0108643-0.1906738,1.9860687,0.4730453,2.1767426,1.4842758c0.1914062,1.0108643-0.4730453,1.9857025-1.4839096,2.1771049
							l-11.3764038,2.1534538C70.523819,49.0283508,70.4073792,49.0389061,70.2923965,49.0389061z"/>
					</g>
					<g className="eyes--is-being-pet--likes">
						<path className="fill--face" d="M40.3782349,48.9296188c-0.4488602,0-0.8984489-0.161705-1.2552185-0.4894714
							c-0.6823616-0.6265221-2.1558495-1.3353462-4.2457085-1.4452057c-2.0884094-0.1058731-3.6293354,0.4412498-4.3733311,0.9934425
							c-0.8244858,0.61166-1.9861641,0.4387131-2.5967331-0.3839607c-0.6112938-0.8230362-0.439436-1.9858017,0.3836002-2.5970955
							c1.6591244-1.2320175,4.1217079-1.8603516,6.7808037-1.7200394c2.6496696,0.1392288,5.0419121,1.0209999,6.5632591,2.419075
							c0.7548714,0.6935997,0.8049088,1.8679657,0.1109467,2.6228371
							C41.3796577,48.7276688,40.8800354,48.9296188,40.3782349,48.9296188z"/>
						<path className="fill--face" d="M70.4927902,48.9296188c0.4488602,0,0.8984528-0.161705,1.2552185-0.4894714
							c0.6823578-0.6265221,2.1558456-1.3353462,4.2457047-1.4452057c2.0884094-0.1058731,3.6293411,0.4412498,4.3733368,0.9934425
							c0.8244858,0.61166,1.9861603,0.4387131,2.5967331-0.3839607c0.61129-0.8230362,0.4394302-1.9858017-0.383606-2.5970955
							c-1.6591187-1.2320175-4.1217041-1.8603516-6.7807999-1.7200394c-2.6496658,0.1392288-5.0419159,1.0209999-6.5632629,2.419075
							c-0.7548676,0.6935997-0.8049011,1.8679657-0.1109467,2.6228371
							C69.4913635,48.7276688,69.9909897,48.9296188,70.4927902,48.9296188z"/>
					</g>
				</svg>
			</div>
		);
	}
}

export default KittenInTab;



// WEBPACK FOOTER //
// ./src/components/Site/Home/KittenInTab.js